import { useMemo } from 'react'

const XML_ESCAPES: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&apos;' }

/**
 * Tiled, diagonal "who is viewing" text over the document, so screenshots and
 * photos of the screen carry the viewer's identity. Purely visual: it does not
 * block clicks or scrolling.
 */
export function Watermark({ text }: { text: string }) {
  const background = useMemo(() => {
    const safe = text.replace(/[&<>"']/g, (c) => XML_ESCAPES[c] ?? c)
    const svg =
      `<svg xmlns='http://www.w3.org/2000/svg' width='440' height='250'>` +
      `<text x='220' y='125' text-anchor='middle' dominant-baseline='middle' transform='rotate(-22 220 125)' ` +
      `font-family='-apple-system,BlinkMacSystemFont,Segoe UI,sans-serif' font-size='14' font-weight='600' ` +
      `letter-spacing='0.5' fill='rgb(118,118,128)' fill-opacity='0.2'>${safe}</text></svg>`
    return `url("data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}")`
  }, [text])
  return (
    <div
      aria-hidden
      data-testid="watermark"
      className="pointer-events-none absolute inset-0 z-10 select-none"
      style={{ backgroundImage: background }}
    />
  )
}
